import _ from 'lodash';
import { getMediaDocumentDownloadUrl, getPdfDocumentUrl, getPdfImageUrl } from 'services/patientRecordServices';
import { CdrDocumentFileContent, PatientMedicalDocumentDto, PatientMedicalDocumentFileDto } from 'ts-types/api.types';

export const includesImage = (document: PatientMedicalDocumentDto): boolean => {
  if (!document) {
    return false;
  }

  return !_.isEmpty(document.files)
      && document.files.findIndex(file => isImageFile(file)) >= 0;
};

export const isImageFile = (file: PatientMedicalDocumentFileDto): boolean => {
  if (!file) {
    return false;
  }

  const fileType = file.fileType;
  return !_.isNil(fileType) && fileType.startsWith("image");
};

export const isPdfFile = (file: CdrDocumentFileContent): boolean => {
  if (!file) {
    return false;
  }

  const contentType = file.contentType;
  return !_.isNil(contentType) && contentType.endsWith("pdf");
};

export const getPatientDocumentFileUrl = (documentResponse: CdrDocumentFileContent): string => {

  const contentType = documentResponse.contentType;

  if (isPdfFile(documentResponse)) {
    return getPdfDocumentUrl(documentResponse.pdfId, documentResponse.pdfName);
  } else if (contentType.startsWith("image")) {
    const fileType = contentType.split("/")[1];
    return getPdfImageUrl(documentResponse.pdfId, documentResponse.pdfName, fileType);
  } else if (contentType.startsWith("audio")
      || contentType.startsWith("video")) {
    return getMediaDocumentDownloadUrl(documentResponse);
  } else {
    throw new Error("Unsupported content type")
  }
}
